import React, {
  useState, useRef
} from "react";
import ReactDOM from "react-dom";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import { ThemeProvider } from "@material-ui/core/styles";
import { defaultTheme } from "../../theme";

export function Alert(props){
  const {
    handleSubmit : inHandleSubmit,
    text = "确定要删除该记录吗？"
  } = props;
  const [open, setOpen] = useState(true);
  const parent = useRef(document.getElementById("custom-alert"));

  const handleClose = () => {
    setOpen(false);
    document.body.removeChild(parent.current);
  }

  const handleSubmit = () => {
    setOpen(false);
    document.body.removeChild(parent.current);
    inHandleSubmit && inHandleSubmit()
  }

  return (
    <ThemeProvider theme={defaultTheme}>
      <Dialog
        open    = {open}
        onClose = {handleClose}
        fullWidth
        maxWidth = "xs"
      >
        <DialogTitle>
          警告
        </DialogTitle>
        <DialogContent>
          {text}
        </DialogContent>
        <DialogActions>
          <Button size="small" variant="contained" onClick={handleClose}>
            取消
          </Button>
          <Button size="small" variant="contained" color="secondary" onClick={handleSubmit}>
            确定
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  )
}

export default function AlertWrapper(props){
  const {
    handleSubmit,
    text
  } = props;

  let element = document.getElementById("custom-alert");
  if(!element){
    element = document.createElement("div");
    element.id = "custom-alert";
    document.body.appendChild(element);
  }
  
  ReactDOM.render(
    <Alert
      handleSubmit = { handleSubmit }
      text         = { text }
    />
  , element)
}